import { useEffect, useState, useCallback } from "react";
import { sharingInformationService } from "../../../services/sharingInformationService";

function useReplyMessageSubscription() {
  const [replyMessage, setReplyMessage] = useState(null);

  useEffect(() => {
    const subscription$ = sharingInformationService.getSubject();

    const sub = subscription$.subscribe((data) => {
      if (data.selectMessageToReply) {
        setReplyMessage(data.message);
      }
    });

    return () => sub.unsubscribe();
  }, []);

  const clearReplyMessage = useCallback(() => {
    setReplyMessage(null);
  }, []);

  return {
    replyMessage,
    clearReplyMessage,
  };
}

export default useReplyMessageSubscription;